import { FeedbackSubmission, Feedback, FeedbackStats } from '../types/feedback'
import { apiClient } from '../utils/apiClient'

/**
 * Feedback Service for submitting and managing user feedback
 */
class FeedbackService {
  /**
   * Submit user feedback
   */
  async submitFeedback(data: FeedbackSubmission): Promise<void> {
    await apiClient.post('/api/feedback', data)
  }

  /**
   * Get all feedback (admin)
   */
  async getAllFeedback(filters?: { status?: string; rating?: string }): Promise<Feedback[]> {
    const params = new URLSearchParams(filters as any)
    return apiClient.get<Feedback[]>(`/api/feedback?${params}`)
  }

  /**
   * Get feedback statistics (admin)
   */
  async getStats(): Promise<FeedbackStats> {
    return apiClient.get<FeedbackStats>('/api/feedback/stats')
  }

  /**
   * Update feedback status (admin)
   */
  async updateStatus(id: string, status: string, adminNotes?: string): Promise<Feedback> {
    // Use raw fetch for PATCH since apiClient doesn't have a patch method
    return apiClient.put<Feedback>(`/api/feedback/${id}`, { status, adminNotes })
  }

  /**
   * Delete feedback (admin)
   */
  async deleteFeedback(id: string): Promise<void> {
    await apiClient.delete(`/api/feedback/${id}`)
  }
}

// Export singleton instance
export const feedbackService = new FeedbackService()
export default feedbackService
